
const markets = {
  general: {
    name: "Nom",
    groups: "Périmètre",
    status: "Statut du marché",
    datebegin: "Date de début",
    dateend: "Date de fin",
    energy: "Fluide associé",
    marketnumber: "Numéro de marché",
    associateddocuments: "Pièces de marché associées",
    otherfiles: "Autres fichiers associés",
    hideclosed: "Cacher les marchés fermés",
  },
  provider: {
    name: "Fournisseur",
    inchargename: "Nom du responsable",
    address: "Adresse postale",
    phone: "Numéro de téléphone",
    email: "Adresse email",
    requestemail: "Adresse email - Demandes",
    contactname: "Nom du contact",
    contactfunction: "Rôle"
  },
  marketresponsible: {
    name: "Responsable du marché",
    inchargename: "Nom du responsable",
    address: "Adresse postale",
    phone: "Numéro de téléphone",
    email: "Adresse email",
    requestemail: "Adresse email - Demandes",
  },
  membershipcount: "Nombre d'adhérents",
  markets: "Groupements d'achat",
  nomarkets: "Aucun marché",
  seemarketdetails: "Voir les détails du marché",
  gotoserviceorders: "Aller aux ordres de service",
};

const memberships = {
  marketmembershipnumber: "Numéro d'adhérent au marché",
  name: "Nom adhérent",
  internalmembershipnumber: "Numéro interne d'adhérent",
  status: "Statut adhésion",
  dateupdate: "Date de mise à jour",
  daterequest: "Date de demande",
  datemembership: "Date d'adhésion",
  dateend: "Date de sortie",
  contactname: "Nom du contact principal",
  contactjob: "Poste / Fonction",
  company: "Structure / Société",
  siret: "Code SIRET",
  phone: "Téléphone",
  email: "Email",
  billingaddress: "Adresse de facturation",
  comments: "Commentaires",
  associatedfiles: "Fichiers associés",
  description: "Description",
  groups: "Périmètre",
}

const meters = {
  meternumber: "Numéro de compteur",
  status: "Statut dans le marché",
  datebegin: "Date d'entrée",
  dateend: "Date de sortie",
  description: "Description",
  marketmembershipnumber: "N° Adhérent au marché",
  marketmembershipname: "Nom d'adhérent",
  segment: "Segment",
  acheminement: "Acheminement",
  profil: "Profil",
}

const mandates = {
  docnumber: "N° du document",
  docname: "Nom du document",
  legalentity: "Entité légale",
  representedby: "Représentée par",
  datebegin: "Date de début",
  dateend: "Date de fin",
  datesignature: "Date de signature",
  status: "Statut",
  associatedfiles: "Document associé",
  marketmembershipnumber: "N° Adhérent au marché",
  marketmembershipname: "Nom d'adhérent",
}

const membercontracts = {
  docnumber: "N° du document",
  docname: "Nom du document",
  legalentity: "Entité légale",
  representedby: "Représentée par",
  datebegin: "Date de début",
  dateend: "Date de fin",
  datesignature: "Date de signature",
  status: "Statut",
  associatedfiles: "Document associé",
  marketmembershipnumber: "N° Adhérent au marché",
  marketmembershipname: "Nom d'adhérent",
}

const marketcontracts = {
  docnumber: "N° du document",
  docname: "Nom du document",
  legalentity: "Entité légale",
  representedby: "Représentée par",
  datebegin: "Date de début",
  dateend: "Date de fin",
  datesignature: "Date de signature",
  status: "Statut",
  associatedfiles: "Document associé",
}

const marketotherfiles = {
  doctype: "Type de document",
  docnumber: "N° du document",
  docname: "Nom du document",
  legalentity: "Entité légale",
  representedby: "Représentée par",
  datebegin: "Date de début",
  dateend: "Date de fin",
  datesignature: "Date de signature",
  status: "Statut",
  associatedfiles: "Document associé",
}

const memberorder = {
  ordertype: "Type d'ordre de service",
  status: "Statut",
  generatedfile: "Ordre de service généré",
  marketmembershipname: "Nom de l'adhérent",
  marketmembershipnumber: "Numéro d'adhérent",
  marketmembershipaddress: "Adresse de l'adhérent",
  marketmembershipsiret: "SIRET de l'adhérent",
  author: "Nom du créateur de l'ordre",
  referentname: "Nom du responsable sur site",
  referentemail: "Adresse mail du responsable sur site",
  referentphone: "Téléphone du responsable sur site",
  pdl: "Numéro de PDL",
  pdlifknown: "Numéro de PDL (si connu)",
  pdladdress: "Adresse du PDL",
  pdlnewaddress: "Nouvelle adresse du PDL",
  pdlinseecode: "Code INSEE de l'adresse du PDL",
  pdlreferenceconsumption: "Consommation de référence",
  pdlname: "Nom du PDL",
  pdlusagecode: "Code usage du PDL",
  pdlnewname: "Nouveau nom du PDL",
  pdldropmeter: "Dépose du compteur souhaitée",
  pdlcontractualdata: "",
  comments: "Commentaires",
  startdate: "Date de mise en service",
  enddate: "Date de résiliation",
  executiondate: "Date de réalisation souhaitée",
  renewablemix: "Mix énergétique",
  billregroupname: "Intitulé du regroupement de facture",
  billregroupcode: "Code du regroupement de facture",
  billbudgetcode: "Code d'imputation budgétaire",
  creationdate: "Date de création",
  validationdate: "Date de soumission",
  electricity: {
    pdltype: "Type de PDL",
    turpe: "Version du TURPE",
    psousbase: "Puissance souscrite Base (kVA)",
    psoushp: "Puissance souscrite HP (kVA)",
    psoushc: "Puissance souscrite HC (kVA)",
    psoushph: "Puissance souscrite HPH (kVA)",
    psoushch: "Puissance souscrite HCH (kVA)",
    psoushpe: "Puissance souscrite HPB (kVA)",
    psoushce: "Puissance souscrite HCB (kVA)",
    psouspointe: "Puissance souscrite Pointe (kVA)",
    nbhour: "Nombre d'heure d'utilisation (si PDL sans comptage)",
  },
  gas: {
    profil: "Profil de consommation",
    tarif: "Option tarifaire"
  },
  fileunavailable: "Fichier non disponible",
  filegenerated: "Fichier généré",
  sendtoprovider: "Envoyer l'ordre de service au fournisseur",
  validateserviceorder: "Valider l'ordre de service",
  nocontacts: "L'ordre de service ne peut pas être envoyé automatiquement, aucun contact fournisseur détecté",
  numeroaffaire: "Numéro d'affaire",
  associatedaccount: "Compte associé",
  associatedmarket: "Marché associé",
  marketparameters: "Paramètres dans le marché",
  generalparameters: "Paramètres généraux",
  tractivationparameters: "Activation des collectes",
  trdeactivationparameters: "Désactivation des collectes",
  attributionparameters: "Paramètres d'attribution du compteur",
  pagenext: "Suivant",
  validate: "Valider",
  noteattribution: "Ce compteur doit être attribué à une entité de votre architecture. Merci de choisir une entité et de valider les paramètres d'attribution."
}

const memberclaim = {
  status: "Statut",
  marketmembershipname: "Nom de l'adhérent",
  marketmembershipnumber: "Numéro d'adhérent",
  author: "Nom du créateur de la réclamation",
  comments: "Commentaires",
  enddate: "Date de fin",
  creationdate: "Date de création",
  validationdate: "Date de soumission",
  purpose: "Objet de la réclamation",
  detail: "Détail",
  amountasked: "Montant demandé",
  amountreceived: "Montant reçu",
  associatedfiles: "Fichiers associés",
  rejectioncause: "Raison du refus",
}

export { markets, memberships, meters, mandates, membercontracts, marketcontracts, marketotherfiles, memberorder, memberclaim };
